// extracted by mini-css-extract-plugin
module.exports = {"container":"browserSpecificSiteSettings_container__RgFoK","options":"browserSpecificSiteSettings_options__AglGH","label":"browserSpecificSiteSettings_label__fZLV0"};